import React from 'react'

export default function Method({ method }) {
  const { img, title, description, alt, pos } = method

  if(pos === "right" && window.innerWidth > 550){
    return (
      <div className="method method_right">
        <div className="item text_container">
          <h3 className="method_title">
            {title}
          </h3>
          <div className="text">
            {description}
          </div>
        </div>
        <div className="item img_container">
          <img src={img} alt={alt} />
        </div>
      </div>
    )
  } else {
    return (
      <div className="method">
        <div className="item img_container">
          <img src={img} alt={alt} />
        </div>
        <div className="item text_container">
          <h3 className="method_title">
            {title}
          </h3>
          <div className="text">
            {description}
          </div>
        </div>
      </div>
    )
  }
}
